
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";
import { LucideIcon } from "lucide-react";
import { useLocation } from "react-router-dom";

interface SidebarItemProps {
  title: string;
  icon: LucideIcon;
  href: string;
  onClick?: () => void;
}

const SidebarItem = ({ title, icon: Icon, href, onClick }: SidebarItemProps) => {
  const location = useLocation();
  const isActive = location.pathname === href;

  return (
    <Button
      variant={isActive ? "secondary" : "ghost"}
      className={cn(
        "justify-start",
        isActive
          ? "bg-secondary text-secondary-foreground"
          : "text-muted-foreground hover:text-foreground"
      )}
      onClick={onClick}
      asChild
    >
      <Link to={href}>
        <Icon className="mr-2 h-4 w-4" />
        {title}
      </Link>
    </Button>
  );
};

export default SidebarItem;
